import { render, staticRenderFns } from "./apiDocIndex.vue?vue&type=template&id=54c1faca&scoped=true&"
import script from "./apiDocIndex.vue?vue&type=script&lang=js&"
export * from "./apiDocIndex.vue?vue&type=script&lang=js&"
import style0 from "./apiDocIndex.vue?vue&type=style&index=0&id=54c1faca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c1faca",
  null
  
)

export default component.exports